"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION = void 0;
var pn_any_address_based_types_1 = require("./pn-any-address-based-types");
Object.defineProperty(exports, "ACTION", { enumerable: true, get: function () { return pn_any_address_based_types_1.ACTION; } });
//# sourceMappingURL=pn-any-reference-based-types.js.map